import { Injectable } from '@angular/core';
import { HttpClient } from '../_services/global-http.service';

import { Observable } from 'rxjs/Observable';
import { PaginationParams } from '../_models/generic';
import { ReportNotificationsEmail, DailyNotificationsEmail, ICheckReportNotificationsPaginationApi, ICheckReportNotificationsRow } from '../_models/vehicle-check';
import { Utilities } from '../_utilities/Utilities';
@Injectable()

export class NotificationEmailsService {
  constructor(private http: HttpClient) { }

  data: any;

  public getReportNotificationEmails(reportType: string) {
    const reportParamValue = {
      STD: 'vehicle_std_emails',
      AUD: 'vehicle_audit_emails',
      HND: 'vehicle_handover_emails',
      DEFECT: 'defect_notification_emails'
    };

    const url = `/api/add_report_emails_to_customer/?notification_type=${reportParamValue[reportType]}`;
    return this.http.get(url);
  }

  public putReportNotificationEmails(data: ReportNotificationsEmail) {

    const url = `/api/add_report_emails_to_customer/`;
    return this.http.put(url, data);
  }


  public getDailyNotificationEmails(emailType: string, id: number) {

    const url = `/api/add_remove_notification_emails/?${emailType}=${id}`;
    return this.http.get(url);
  }

  // New Check Report Notification API's
  public findCheckReportNotificationEmails(params: PaginationParams): Observable<ICheckReportNotificationsPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<ICheckReportNotificationsPaginationApi>('/api/report_notification_emails/', { params: _params });
  }

  public postCheckReportNotificationEmail1(data: {email: string, customer?: number}) {
    return this.http.post('/api/report_notification_emails/', data);
  }
  postCheckReportNotificationEmail(data: any) {
    let api = '/api/report_notification_emails/';
    this.data = this.http.post(api, data);
    return this.data;
  }

  public deleteCheckReportNotificationEmail(emailId: number): Observable<ICheckReportNotificationsRow> {
    return this.http.delete(`/api/report_notification_email_delete/${emailId}/`);
  }

  // Update the e,mail address with selected depots
  public putReportNotificationEmailDepots(data: any): Observable<ICheckReportNotificationsRow> {
    return this.http.put('/api/report_notification_email_depots/', data);
  }



  // Add Daily Regional and Depot notification emails
  public putDailyNotificationEmails(data: DailyNotificationsEmail) {

    const url = `/api/add_remove_notification_emails/`;
    return this.http.put(url, data);
  }


}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/notification-emails.service.ts